<template>
  <iframe :src="url" frameborder="0" style="width: 100%; height: 1920px"></iframe>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: 'PDFModal',
  components:{
    pdf
  },
  data(){
    return {
      url:"./static/20211020互联网药品信息服务资格证.pdf",
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PDFModal.vue